import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface ChartData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    backgroundColor?: string;
    borderColor?: string;
  }[];
}

@Component({
  selector: 'app-charts',
  imports: [CommonModule],
  template: `
    <div [class]="chartClasses">
      <div class="p-4 border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">{{ title() }}</h3>
        <div class="h-64 flex items-center justify-center text-gray-500 dark:text-gray-400">
          <p>Chart visualization placeholder</p>
          <p class="text-sm mt-2">Data: {{ data()?.datasets?.[0]?.data?.length || 0 }} points</p>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class ChartsComponent {
  type = input<'line' | 'bar' | 'pie' | 'doughnut'>('bar');
  data = input<ChartData | null>(null);
  title = input<string>('Chart');
  height = input<string>('256px');

  get chartClasses(): string {
    return 'w-full';
  }
}

